// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5b-1";
export var standaloneTable = "_5b-0";